export default function PageJsonLd() {
  const baseUrl = 'https://business-training.by';
  const pageUrl = `${baseUrl}/enciklopediya-korporativnogo-obucheniya/ocenka-effektivnosti-obucheniya`;

  const breadcrumb = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: [
      { '@type': 'ListItem', position: 1, name: 'Главная', item: { '@id': baseUrl, name: 'Главная' } },
      { '@type': 'ListItem', position: 2, name: 'Энциклопедия корпоративного обучения', item: { '@id': `${baseUrl}/enciklopediya-korporativnogo-obucheniya/chto-takoe-korporativnoe-obuchenie`, name: 'Энциклопедия корпоративного обучения' } },
      { '@type': 'ListItem', position: 3, name: 'Оценка эффективности обучения персонала', item: { '@id': pageUrl, name: 'Оценка эффективности обучения персонала' } },
    ],
  };

  const service = {
    '@context': 'https://schema.org',
    '@type': 'Service',
    name: 'Оценка эффективности обучения персонала',
    description:
      'Профессиональная оценка ROI корпоративного обучения. Модель Киркпатрика, KPI обучения персонала, метрики результативности, анализ влияния тренингов на бизнес-показатели.',
    provider: {
      '@type': 'Person',
      name: 'Алексей Сивко',
      jobTitle: 'Бизнес-тренер, практикующий консультант',
      url: baseUrl,
    },
    areaServed: { '@type': 'Place', name: 'Беларусь, Россия, Казахстан, Израиль' },
    serviceType: 'Корпоративное обучение и оценка эффективности персонала',
    url: pageUrl,
  };

  const organization = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: 'Business Training',
    url: baseUrl,
    description: 'Профессиональное корпоративное обучение в Минске, Беларуси, России, Казахстане и Израиле',
    founder: {
      '@type': 'Person',
      name: 'Алексей Сивко',
    },
  };

  const person = {
    '@context': 'https://schema.org',
    '@type': 'Person',
    name: 'Алексей Сивко',
    jobTitle: 'Бизнес-тренер, практикующий консультант',
    description:
      'Практикующий бизнес-тренер с 18+ лет опыта. 100+ корпоративных проектов, 450+ тренингов, 4500+ участников. Компании Беларуси, России, Казахстана и Израиля.',
    url: baseUrl,
    sameAs: [
      'https://www.linkedin.com/in/sivko-trainer',
      'https://www.instagram.com/sivko_trainer',
    ],
    knowsAbout: [
      'Оценка эффективности обучения',
      'ROI корпоративного обучения',
      'Модель Киркпатрика',
      'KPI обучения персонала',
      'Корпоративное обучение',
      'Развитие сотрудников',
    ],
  };

  const faqQuestions = [
    {
      '@type': 'Question',
      name: 'Как понять, что обучение сотрудников эффективно?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Эффективность определяется по четырём уровням модели Киркпатрика: реакция участников (понравилось ли обучение), усвоение знаний (чему научились), изменение поведения (что изменилось в работе) и бизнес-результат (рост продаж, снижение ошибок, повышение производительности). Настоящая эффективность измеряется на уровнях 3 и 4.',
      },
    },
    {
      '@type': 'Question',
      name: 'Что такое ROI корпоративного обучения?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'ROI обучения — это отношение финансовой отдачи от обучения к затратам на него. Например, если обучение стоило 10 000 BYN, а дополнительная прибыль после обучения составила 50 000 BYN, ROI = (50 000 - 10 000) / 10 000 × 100% = 400%. Это означает, что каждый вложенный рубль принёс 4 рубля прибыли.',
      },
    },
    {
      '@type': 'Question',
      name: 'Как измерить эффективность корпоративного тренинга?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Измерение эффективности тренинга проводится в несколько этапов: замер KPI до обучения (базовый уровень), проведение обучения, повторный замер через 1-3 месяца, сравнение показателей. Используются бизнес-метрики: конверсия, средний чек, длина сделки, количество ошибок, текучесть, скорость адаптации новичков.',
      },
    },
    {
      '@type': 'Question',
      name: 'Какие KPI использовать для оценки обучения?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Для оценки эффективности обучения используются: бизнес-KPI (конверсия, средний чек, длина сделки, повторные продажи, NPS), HR-KPI (текучесть персонала, скорость адаптации новичков, вовлечённость), операционные KPI (количество ошибок, скорость обработки заявок, процент выполнения плана).',
      },
    },
    {
      '@type': 'Question',
      name: 'Можно ли оценить эффективность Soft Skills обучения?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Да, Soft Skills поддаются оценке, но требуют более комплексного подхода. Используются: оценка 360 градусов до и после обучения, наблюдение руководителя за изменением поведения, опросы коллег и клиентов, конкретные бизнес-метрики (снижение конфликтов, рост удовлетворённости клиентов, сокращение времени согласования решений).',
      },
    },
    {
      '@type': 'Question',
      name: 'Когда проводить повторную оценку эффективности обучения?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Рекомендуется проводить повторную оценку через 1-3 месяца после завершения обучения. Этого времени достаточно, чтобы новые навыки закрепились в поведении и начали влиять на бизнес-показатели. Для сложных навыков (управленческих, переговорных) срок может составлять 3-6 месяцев.',
      },
    },
    {
      '@type': 'Question',
      name: 'Кто должен оценивать эффективность обучения?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Оценка эффективности — совместная задача HR (организация процесса, сбор данных), руководителя сотрудника (наблюдение за изменением поведения и результатов) и бизнес-тренера (методология оценки, анализ данных). Ответственность за внедрение результатов обучения лежит на руководителе.',
      },
    },
    {
      '@type': 'Question',
      name: 'Какие ошибки совершают HR при оценке обучения?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Главные ошибки HR: оценивать только реакцию участников (понравился тренинг), не делать замеры до обучения, не согласовывать KPI с бизнесом, не подключать руководителей к оценке, оценивать знания, а не изменение поведения, не анализировать ROI, не давать обратную связь бизнесу по результатам.',
      },
    },
    {
      '@type': 'Question',
      name: 'Как обучение влияет на прибыль компании?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Обучение влияет на прибыль через: рост конверсии продаж (10-30%), увеличение среднего чека, сокращение цикла сделки, снижение количества ошибок и брака, снижение текучести (экономия на подборе и адаптации), ускорение адаптации новичков, рост производительности труда, повышение вовлечённости и, как следствие, инициативности сотрудников.',
      },
    },
    {
      '@type': 'Question',
      name: 'Можно ли оценить эффективность онлайн-обучения?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Да, онлайн-обучение оценивается по тем же принципам, что и очное. Дополнительно доступны цифровые метрики: процент завершения курса, время прохождения, результаты тестирования, скорость ответа на задания. Главный критерий эффективности остаётся неизменным — изменение поведения сотрудника и влияние на бизнес-показатели.',
      },
    },
    {
      '@type': 'Question',
      name: 'Как оценить работу бизнес-тренера?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Работа бизнес-тренера оценивается по результатам обучения группы: изменение KPI участников до и после тренинга, оценка участников (реакция и усвоение), обратная связь от руководителей о внедрении навыков, наличие разработанных материалов (чек-листы, скрипты, алгоритмы), сопровождение после обучения и готовность к анализу ROI.',
      },
    },
    {
      '@type': 'Question',
      name: 'Что делать после обучения, чтобы знания не забылись?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Чтобы знания закрепились, необходимо: домашние задания с конкретными сроками, регулярная обратная связь от руководителя, повторение материала через 2 недели и 2 месяца, внедрение чек-листов и скриптов в ежедневную работу, система наставничества, промежуточная оценка результатов, создание базы знаний с материалами обучения.',
      },
    },
  ];

  const faqPage = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqQuestions,
  };

  return (
    <>
      <script type="application/ld+json">{JSON.stringify(breadcrumb)}</script>
      <script type="application/ld+json">{JSON.stringify(organization)}</script>
      <script type="application/ld+json">{JSON.stringify(service)}</script>
      <script type="application/ld+json">{JSON.stringify(person)}</script>
      <script type="application/ld+json">{JSON.stringify(faqPage)}</script>
    </>
  );
}